<template>
  <div id="header">
    <div class="gnb">
      <!-- 마이페이지 이동 버튼 -->
      <router-link :to="{name: 'myinfo'}" class="mapage"></router-link>

      <!-- 로고 (클릭 시 메인으로 이동 + 스크롤 상단 이동) -->
      <div class="logoBox" @click="scrollToTop">
        <router-link :to="{name: 'main'}" class="logo"></router-link>
      </div>

      <!-- 메뉴 버튼 (햄버거 ↔ 닫기 토글) -->
      <button
        type="button"
        :class="{ btnMenu: !open, btnClose: open }"
        @click="toggleMenu"
      ></button>
    </div>

    <!-- 메뉴 슬라이드 박스 -->
    <div v-if="open" id="menu" class="sectionBox colorBg mainClub scroll">
      <div class="inner">
        <!-- 메뉴 상단 설명 -->
        <div class="innerText">
          <div class="logo"></div>
          <p class="lineTitle"><strong>G MEMBERS</strong></p>
          <p>
            경남FC 팬을 위한 공간 'G멤버스'<br />
            나의 관람 정보를 확인하고 홈경기 혜택을 받아보세요!
          </p>
        </div>

        <!-- 메뉴 버튼 리스트 -->
        <div class="lineBtns" @click="toggleMenu">
          <router-link
            v-for="(link, index) in clubFilter"
            :key="index"
            :to="{name: link.link}"
            :data-club="link.id"
            class="lineBtn"
          >
            <span class="bold ml10">{{ link.club }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: [
    'isLogin' // 로그인 여부 (부모에서 전달)
  ],

  computed: {
    // 로그인 여부에 따라 메뉴 필터링
    // - 미로그인 시: 로그아웃 제외
    // - 로그인 시: 로그인 제외
    clubFilter () {
      const club = this.club
      const isLogin = this.isLogin
      return club.filter(x => {
        return !(x.id === 'logout' && !isLogin) &&
          !(x.id === 'login' && isLogin)
      })
    },

    // 로그인 상태일 경우 사용자 이름
    user () {
      return this.isLogin ? this.$store.state.user.name : null
    },

    // 로그인 상태일 경우 사용자 포인트
    point () {
      return this.isLogin ? this.$store.state.user.point : null
    },

    // 로그인 상태일 경우 전체 예매율
    rate () {
      if (this.isLogin) {
        return this.$store.state.gameData.totalRate !== null
          ? this.$store.state.gameData.totalRate
          : 0
      }
      return null
    }
  },

  watch: {
    // 라우트 변경 시 메뉴 자동 닫기
    $route (to, from) {
      if (to.path !== from.path) {
        this.open = false
      }
    }
  },

  data () {
    return {
      // 사용자 정보/포인트 (현재는 computed에서 가져오므로 사용 X)
      userName: '',
      userPoint: 0,
      totalRate: 0,
      payment_amount: 0,

      // 메뉴 열림 여부
      open: false,

      // 메뉴 목록
      club: [
        { id: 'login', club: '로그인', link: 'login' },
        { id: 'logout', club: '로그아웃', link: 'logout' },
        { id: 'ticket', club: '티켓예매', link: 'ticket' },
        { id: 'attendance', club: '출석체크', link: 'attendance' },
        { id: 'reservation', club: '예매내역 조회', link: 'reservationList' },
        { id: 'event', club: '이벤트 신청', link: 'eventHistory' },
        { id: 'membership', club: '시즌권', link: 'membership' },
        { id: 'survey', club: '설문조사 참여', link: 'surveyHistory' },
        { id: 'point', club: 'G포인트 조회', link: 'pointHistory' },
        { id: 'stadium', club: '경기장 안내', link: 'stadium' },
        { id: 'coupon', club: '쿠폰 조회', link: 'couponHistory' }
      ]
    }
  },

  methods: {
    // 메뉴 열기/닫기 토글
    toggleMenu () {
      const toggle = this.open ? 'remove' : 'add'
      document.body.classList[toggle]('hiddenBody') // body 스크롤 잠금/해제
      this.open = !this.open
    },

    // 스크롤 최상단 이동
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
